<template>
<div class="columns" style="padding: 10px;">
    <div class="column">
        <div class="field">
            <label class="label">First Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Bruce" v-model="input.firstName">
            </div>
       </div>
        <div class="field">
            <label class="label">Last Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Bruce" v-model="input.lastName">
            </div>
       </div>
        <div class="field">
            <label class="label">Staff E-mail</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Staff's E-mail" v-model="input.staffEmail">
            </div>
       </div>
        <div class="field">
            <label class="label">&nbsp;</label>
                <div class='ui two buttons'>
                    <button class='button is-primary' v-on:click="sendForm()">Create</button>
                </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            input: {
                firstName: '',
                lastName: '',
                staffEmail: '',
                isCreating: false,
            },
            result: "",
            errors: []
        };
    },
    beforeMount() {
        this.openForm()
    },
    methods: {        
        openForm() {
            this.input.isCreating = true;
        },
        closeForm() {
            this.input.isCreating = false;
        },
        sendForm() {
            console.log("imini 101")
            //return;
            if (this.input.firstName.length > 0 && this.input.staffEmail.length > 0) {
                const firstName = this.input.firstName;
                this.$emit('teachers-create', {
                    firstName,
                    done: false,
                });

                
                this.input.manageClass = this.tags
                this.input.email = localStorage.getItem('email')
                this.input.sessionID = localStorage.getItem('sessionID')

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/teachers/add', this.input)

                    .then(response => {
                        if (response.data.success == false) {
                            
                            console.log(response.data)
                            var errorCode = response.data.code;
                            if (errorCode == 66){
                                alert("Error, possible duplicate id!")
                            }else{
                                alert(response.data.msg)
                            }
                            // sweetalert({
                            //     title: 'Error',
                            //     text: response.data.msg,
                            //     icon: 'warning',
                            //     buttons: true,
                            //     dangerMode: true,
                            // });
                        } else {
                            //alert("new id: " + response.data._id)
                            this.$parent.getData()

                            this.input.firstName = '';
                            this.input.lastName = '';
                            this.input.staffEmail = '';
                            this.input.isCreating = false;
                            this.manageClass = '';
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            this.errors.push("Invalid login")                            
                            alert("Unauthorized access. Please re-login.")
                        } else {
                            this.errors.push(e)
                                   
                            alert("Error: " + e )
                        }
                    })
            } else {
                alert("Please at least enter the staff's name & email.");
            }
        },        
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Staff/DataCreate.vue